"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _memoize = _interopRequireDefault(require("hs-lodash/memoize"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _Big = _interopRequireDefault(require("UIComponents/elements/Big"));

var _UIDropdownCaret = _interopRequireDefault(require("UIComponents/dropdown/UIDropdownCaret"));

var _AbstractTextElement = _interopRequireDefault(require("UIComponents/elements/AbstractTextElement"));

var _UISearchInput = _interopRequireDefault(require("UIComponents/input/UISearchInput"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var GROUPED_CATEGORIES = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/superCategoryGroups"));

var _UIResponsiveComponent = _interopRequireDefault(require("ecosystem-marketplace-core/components/UIResponsiveComponent"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _superCategoryOrder = _interopRequireDefault(require("../../../constants/superCategoryOrder"));

var _StorefrontUsageTrackerContext = _interopRequireDefault(require("../../../context/StorefrontUsageTrackerContext"));

var _SearchSelectContext = _interopRequireDefault(require("./SearchSelectContext"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: stretch;\n  border-right: 1px solid ", ";\n\n  && .category-dropdown-button {\n    padding-right: 20px;\n    padding-left: 20px;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  border-radius: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ALL_CATEGORIES_OPTION_VALUE = '__ALL_CATEGORIES__';

var SearchSelectInputWrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchSelectInput__SearchSelectInputWrapper",
  componentId: "sc-9hwxdd-0"
})(_templateObject(), _colors.OLAF, _sizes.BUTTON_RADIUS);

var CategorySelectBox = (0, _styledComponents.default)(_UIBox.default).withConfig({
  displayName: "SearchSelectInput__CategorySelectBox",
  componentId: "sc-9hwxdd-1"
})(_templateObject2(), _colors.GREAT_WHITE);
var CategorySelectCaret = (0, _styledComponents.default)(function (props) {
  return _react.default.createElement(_Big.default, null, _react.default.createElement(_UIDropdownCaret.default, props));
}).withConfig({
  displayName: "SearchSelectInput__CategorySelectCaret",
  componentId: "sc-9hwxdd-2"
})(_templateObject3(), _colors.CALYPSO, _colors.CALYPSO_DARK);

var CategorySelectValue = function CategorySelectValue(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_Big.default, null, _react.default.createElement("b", null, children));
};

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.storefront.searchSelect." + key;
};

var getCategorySelectPlaceholder = function getCategorySelectPlaceholder() {
  return (0, _unescapedText.default)(getI18nKey('searchCategorySelectPlaceholder'));
};

var getCategorySelectValue = function getCategorySelectValue(superCategory, category) {
  if (superCategory && category) {
    return superCategory + ":" + category;
  } else if (superCategory) {
    return superCategory;
  }

  return ALL_CATEGORIES_OPTION_VALUE;
};

var getCategorySelectOptions = (0, _memoize.default)(function (showHelpText) {
  var options = _superCategoryOrder.default.reduce(function (final, superCategory) {
    var categories = _immutable.default.Set(Object.values(GROUPED_CATEGORIES[superCategory]));

    var superCategoryText = (0, _unescapedText.default)((0, _i18n.getSuperCategoryI18nKey)(superCategory));
    final.push({
      text: superCategoryText,
      value: superCategory,
      dropdownText: _react.default.createElement(_AbstractTextElement.default, {
        weight: "demi"
      }, superCategoryText)
    });
    return final.concat(categories.map(function (category) {
      return [category, (0, _unescapedText.default)((0, _i18n.getCategoryI18nKey)(category))];
    }).sortBy(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          categoryText = _ref3[1];

      return categoryText;
    }).map(function (_ref4) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
          category = _ref5[0],
          categoryText = _ref5[1];

      return {
        text: categoryText,
        value: getCategorySelectValue(superCategory, category),
        dropdownClassName: 'p-left-4',
        help: showHelpText ? _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('inCategory'),
          options: {
            category: superCategoryText
          }
        }) : null
      };
    }).toArray());
  }, []);

  var placeholder = getCategorySelectPlaceholder();
  return [{
    text: placeholder,
    dropdownText: _react.default.createElement(_AbstractTextElement.default, {
      weight: "demi"
    }, placeholder),
    value: ALL_CATEGORIES_OPTION_VALUE
  }].concat((0, _toConsumableArray2.default)(options));
});

var SearchSelectInput = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(SearchSelectInput, _PureComponent);

  function SearchSelectInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SearchSelectInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SearchSelectInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      categoryInputValue: '',
      categorySelectOpen: false
    };

    _this.handleCategoryInputValueChange = function (evt) {
      _this.setState({
        categoryInputValue: evt.target.value
      });
    };

    _this.handleCategorySelectOpenChange = function (evt) {
      _this.setState({
        categorySelectOpen: evt.target.value,
        categoryInputValue: ''
      });
    };

    return _this;
  }

  (0, _createClass2.default)(SearchSelectInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          categoryInputValue = _this$state.categoryInputValue,
          categorySelectOpen = _this$state.categorySelectOpen;
      return _react.default.createElement(_SearchSelectContext.default.Consumer, null, function (_ref6) {
        var superCategory = _ref6.superCategory,
            category = _ref6.category,
            isSticky = _ref6.isSticky,
            updateSearchFilters = _ref6.updateSearchFilters;
        return _react.default.createElement(_StorefrontUsageTrackerContext.default.Consumer, null, function (_ref7) {
          var trackInteraction = _ref7.trackInteraction;
          return _react.default.createElement(SearchSelectInputWrapper, null, _react.default.createElement(_UIFlex.default, {
            align: "stretch"
          }, _react.default.createElement(CategorySelectBox, {
            grow: 0,
            shrink: 0
          }, _react.default.createElement(_UIResponsiveComponent.default, {
            display: {
              xs: false,
              sm: true
            }
          }, _react.default.createElement(_UIFlex.default, {
            direction: "column",
            justify: "center",
            style: {
              height: '100%'
            }
          }, _react.default.createElement(_UISelect.default, {
            anchorType: "button",
            className: "p-x-5",
            buttonUse: "primary-white",
            caretRenderer: CategorySelectCaret,
            filterOption: function filterOption(_ref8, input) {
              var text = _ref8.text,
                  value = _ref8.value;

              if (!input) {
                return true;
              }

              return value !== ALL_CATEGORIES_OPTION_VALUE && !!~_UISelect.default.stripDiacritics(text.toLowerCase()).indexOf(input);
            },
            inputValue: categoryInputValue,
            itemComponent: "div",
            menuWidth: 250,
            open: categorySelectOpen,
            onChange: function onChange(_ref9) {
              var value = _ref9.target.value;

              if (value === ALL_CATEGORIES_OPTION_VALUE) {
                updateSearchFilters();
              } else {
                var _value$split = value.split(':'),
                    _value$split2 = (0, _slicedToArray2.default)(_value$split, 2),
                    optionSuperCategory = _value$split2[0],
                    optionCategory = _value$split2[1];

                updateSearchFilters(optionSuperCategory, optionCategory);
              }

              trackInteraction('select search category', {
                value: value
              }, 'storefront-select-search-category');
            },
            onInputValueChange: _this2.handleCategoryInputValueChange,
            onOpenChange: _this2.handleCategorySelectOpenChange,
            options: getCategorySelectOptions(!!categoryInputValue),
            placeholder: getCategorySelectPlaceholder(),
            searchable: true,
            value: getCategorySelectValue(superCategory, category),
            valueComponent: CategorySelectValue
          })))), _react.default.createElement(_UISearchInput.default, (0, _extends2.default)({}, _this2.props, {
            autoComplete: "off",
            placeholder: (0, _unescapedText.default)(getI18nKey('searchInputPlaceholder')),
            size: isSticky ? 'default' : 'extra-large',
            styled: false
          }))));
        });
      });
    }
  }]);
  return SearchSelectInput;
}(_react.PureComponent);

var _default = SearchSelectInput;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/search/SearchSelectInput.js
// module id = 763
// module chunks = 209 210 211 212